'use client';

import styled from 'styled-components';

const MoveUpStyle = styled.section`
	--distanceTitleContent: var(--sp9x);

	.title-section {
		margin-bottom: var(--distanceTitleContent);
	}

	.content-wrapper {
		.row {
			row-gap: var(--gutter);
		}
	}

	.item-move {
		transform: translateY(70%);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceTitleContent: var(--sp7x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTitleContent: var(--sp6x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceTitleContent: var(--sp4x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;
export default MoveUpStyle;
